import { CircularProgress, Grid } from '@mui/material';

export const LoadingInline = () => {
  return (
    <Grid container justifyContent="center">
      <CircularProgress color="secondary" />
    </Grid>
  );
};
